<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{ 'FLEET-FUEL-IDLENESS' | translate }}</span>
        <div class="header-buttons">
            <button class="fab-button primary" appFiltersButton pTooltip="Exibir/Ocultar Filtros" tooltipPosition="left">
                <i class="pi pi-filter"></i>
            </button>
        </div>
    </p-header>

    <form class="filters" (submit)="loadReport()" appFilters>
        <div class="filter-row">
            <div class="form-control">
                <label for="windowDays">{{ 'IDLENESS-WINDOW' | translate }}</label>
                <p-dropdown [options]="windowOptions" [(ngModel)]="windowDays" name="windowDays" appendTo="body"
                    (onChange)="onChangeWindow()">
                </p-dropdown>
            </div>
            <div class="buttons">
                <div class="form-button">
                    <button class="easymarine primary" type="submit">{{ 'FIND' | translate }}</button>
                </div>
            </div>
        </div>
    </form>

    <div *ngIf="report" class="coverage-banner">
        <span>
            {{ 'FUEL-COVERAGE' | translate }}:
            <strong>{{ report.fuelCoveragePercent }}%</strong>
            ({{ report.boatsWithFuelInfo }}/{{ report.totalBoats }} {{ 'BOAT' | translate }})
        </span>
        <span class="window-info">
            {{ 'IDLENESS-WINDOW' | translate }}: {{ report.windowDays }} {{ 'DAYS' | translate }}
        </span>
    </div>

    <div *ngFor="let group of report?.groups" class="fuel-group">
        <h3 class="fuel-group-title">
            {{ group.fuelType }}
            <span class="fuel-group-count">({{ group.boatCount }})</span>
        </h3>
        <div class="table">
            <p-table [value]="group.boats" styleClass="easy-table" autoLayout="true" [paginator]="false">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="text-center" [pSortableColumn]="'boatName'">
                            {{ 'BOAT' | translate }}
                            <p-sortIcon [field]="'boatName'"></p-sortIcon>
                        </th>
                        <th class="text-center" [pSortableColumn]="'lastSortieDate'">
                            {{ 'LAST-SORTIE' | translate }}
                            <p-sortIcon [field]="'lastSortieDate'"></p-sortIcon>
                        </th>
                        <th class="text-center" [pSortableColumn]="'daysSinceLastSortie'">
                            {{ 'DAYS-IDLE' | translate }}
                            <p-sortIcon [field]="'daysSinceLastSortie'"></p-sortIcon>
                        </th>
                        <th class="text-center">{{ 'FLEET-BOAT-STATUS' | translate }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-boat>
                    <tr [class.idle-row]="boat.idleBeyondWindow">
                        <td class="text-center">{{ boat.boatName }}</td>
                        <td class="text-center">
                            {{ boat.neverNavigated ? '-' : (boat.lastSortieDate | date: 'dd/MM/yyyy') }}
                        </td>
                        <td class="text-center">
                            {{ boat.neverNavigated ? ('NEVER-NAVIGATED' | translate) : boat.daysSinceLastSortie }}
                        </td>
                        <td class="text-center">
                            <span *ngIf="boat.neverNavigated" class="tag tag-idle">
                                {{ 'NEVER-NAVIGATED' | translate }}
                            </span>
                            <span *ngIf="!boat.neverNavigated && boat.idleBeyondWindow" class="tag tag-idle">
                                {{ 'IDLE' | translate }}
                            </span>
                            <span *ngIf="!boat.neverNavigated && !boat.idleBeyondWindow" class="tag tag-ok">OK</span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" class="text-center">{{ 'TOTAL-REGISTERS' | translate }}: 0</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</p-fieldset>